function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/* eslint-disable max-len */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import DayPickerInput from 'react-day-picker/DayPickerInput';
import moment from 'moment';
import MomentLocaleUtils from 'react-day-picker/moment';
import noop from "../../utils/noop";
import { KEYS } from "../../constants";
import Navbar from "./navbar/navbar";
import Input from "./input/input";
import Caption from "./caption/caption";

var DayInput =
/*#__PURE__*/
function (_Component) {
  _inherits(DayInput, _Component);

  function DayInput(props, context) {
    var _this;

    _classCallCheck(this, DayInput);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DayInput).call(this, props, context));

    _defineProperty(_assertThisInitialized(_this), "getLocaleUtils", function (shortMonth) {
      var getMonths = function getMonths(locale) {
        var localeMoment = moment().locale(locale || 'en');
        var monthFormat = shortMonth ? 'MMM' : 'MMMM';
        var months = []; // eslint-disable-next-line max-len

        for (var i = 0; i < 12; i++) {
          months.push(localeMoment.month(i).format(monthFormat).replace(/\.$/, ''));
        }

        return months;
      };

      return _objectSpread({}, MomentLocaleUtils, {
        getMonths: getMonths
      });
    });

    _defineProperty(_assertThisInitialized(_this), "formatDate", function (date) {
      var dateMoment = moment(date);
      return dateMoment.isValid() ? dateMoment.format(_this.dateFormat) : '';
    });

    _defineProperty(_assertThisInitialized(_this), "handleDayPickerInputKeyUp", function (e) {
      if (e.keyCode === KEYS.ENTER && _this.dayPickerInput) if (!_this.parseDate(e.target.value)) _this.dayPickerInput.handleInputChange(_objectSpread({}, e, {
        target: _objectSpread({}, e.target, {
          value: _this.formatDate(Date.now())
        })
      }));else if (_this.showOverlay) _this.dayPickerInput.hideDayPicker();
    });

    _defineProperty(_assertThisInitialized(_this), "handleDayPickerInputBeforeKeyDown", function (e) {
      if (e.keyCode === KEYS.ENTER && _this.dayPickerInput) {
        e.preventDefault();
        _this.showOverlay = _this.dayPickerInput.state.showOverlay;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleYearMonthChange", function (date) {
      _this.setState({
        date: date
      });
    });

    _defineProperty(_assertThisInitialized(_this), "parseDate", function (dateString) {
      var dateMoment = moment(dateString, _this.dateFormat, true);
      return dateMoment.isValid() ? dateMoment.toDate() : undefined;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function () {
      var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          returnEventIfError = _this$props.returnEventIfError;
      if (!onChange) return;
      var dateMoment = moment(date);
      var dateStringOrEvent;

      if (!dateMoment.isValid() && returnEventIfError) {
        var value = '';

        if (_this.dayPickerInput) {
          var input = _this.dayPickerInput.getInput(); // eslint-disable-next-line prefer-destructuring


          if (input) value = input.value;
        }

        dateStringOrEvent = {
          target: {
            value: value
          }
        };
      } else dateStringOrEvent = _this.formatDate(date);

      onChange(dateStringOrEvent, {
        dateMoment: dateMoment
      });
    });

    _this.state = {
      date: _this.parseDate(props.value)
    };
    return _this;
  }

  _createClass(DayInput, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.focus();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps() {
      this.focus();
    }
  }, {
    key: "focus",
    value: function focus() {
      if (this.dayPickerInput && this.props.focus) {
        var input = this.dayPickerInput.getInput();
        if (input) input.focus();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          shortMonth = _this$props2.shortMonth,
          disabled = _this$props2.disabled,
          renderTodayButton = _this$props2.renderTodayButton,
          minDate = _this$props2.minDate,
          maxDate = _this$props2.maxDate,
          name = _this$props2.name,
          value = _this$props2.value,
          formatMessage = _this$props2.formatMessage,
          todayLabel = _this$props2.messages.todayLabel,
          dayPickerOptions = _this$props2.dayPickerOptions,
          dayPickerInputOptions = _this$props2.dayPickerInputOptions;
      var fromMonth = this.parseDate(minDate);
      var toMonth = this.parseDate(maxDate);
      return React.createElement(DayPickerInput, _extends({
        ref: function ref(instance) {
          _this2.dayPickerInput = instance;
        },
        placeholder: this.dateFormat,
        format: this.dateFormat,
        formatDate: this.formatDate,
        parseDate: this.parseDate,
        onDayChange: this.handleChange,
        inputProps: {
          disabled: disabled,
          name: name,
          className: 'DateField-form-control form-control DayPickerInput-input',
          onKeyUp: this.handleDayPickerInputKeyUp,
          onBeforeKeyDown: this.handleDayPickerInputBeforeKeyDown
        },
        value: value,
        component: Input,
        dayPickerProps: _objectSpread({
          month: this.state.date,
          fromMonth: fromMonth,
          toMonth: toMonth,
          locale: 'en',
          localeUtils: this.getLocaleUtils(shortMonth),
          showOutsideDays: false,
          enableOutsideDaysClick: false,
          canChangeMonth: true,
          navbarElement: Navbar,
          captionElement: function captionElement(_ref) {
            var date = _ref.date,
                locale = _ref.locale,
                localeUtils = _ref.localeUtils;
            return React.createElement(Caption, {
              fromMonth: fromMonth,
              toMonth: toMonth,
              date: date,
              locale: locale,
              localeUtils: localeUtils,
              onChange: _this2.handleYearMonthChange
            });
          },
          todayButton: renderTodayButton ? formatMessage(todayLabel) : '',
          modifiers: {
            disabled: {
              before: fromMonth,
              after: toMonth
            }
          }
        }, dayPickerOptions)
      }, dayPickerInputOptions));
    }
  }, {
    key: "dateFormat",
    get: function get() {
      return this.props.dateFormat || DayInput.defaultProps.dateFormat;
    }
  }]);

  return DayInput;
}(Component);

_defineProperty(DayInput, "propTypes", {
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  disabled: PropTypes.bool,
  minDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  maxDate: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Date)]),
  focus: PropTypes.bool,
  shortMonth: PropTypes.bool,
  dateFormat: PropTypes.string,
  renderTodayButton: PropTypes.bool,
  formatMessage: PropTypes.func,
  messages: PropTypes.shape({
    todayLabel: PropTypes.object
  }),
  dayPickerOptions: PropTypes.object,
  dayPickerInputOptions: PropTypes.object,
  returnEventIfError: PropTypes.bool
});

_defineProperty(DayInput, "defaultProps", {
  onChange: noop,
  dateFormat: 'YYYY-MM-DD',
  focus: false,
  shortMonth: false,
  renderTodayButton: true,
  formatMessage: noop,
  messages: {},
  returnEventIfError: false
});

export { DayInput as default };